export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/selection/empty.js
// module id = ../../../../d3-selection/src/selection/empty.js
// module chunks = 4